var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99993 10.8002C3.0149 10.8002 1.3999 9.27915 1.3999 7.40955C1.3999 4.8002 4.99996 1.2002 4.99996 1.2002C4.99996 1.2002 8.5999 4.8002 8.5999 7.40955C8.5999 9.27918 6.98495 10.8002 4.99993 10.8002ZM4.99993 10.8002C4.00742 10.8002 3.1999 10.0397 3.1999 9.10487C3.1999 7.8002 4.99993 6.0002 4.99993 6.0002C4.99993 6.0002 6.7999 7.8002 6.7999 9.10487C6.7999 10.0397 5.99244 10.8002 4.99993 10.8002Z",
    stroke: "black",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.3c3d1f2c2552b9fab90840afbd54b2cb.svg";
export { ForwardRef as ReactComponent };